import { Component, OnInit } from '@angular/core';
import { CouponsService } from '../../../../services/coupons.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.scss'],
})
export class CouponsComponent implements OnInit {
  public partner: any;
  public coupons: any = [];
  public busy: boolean = false;
  public selectedCoupon: any = {};
  public showCouponDetail: boolean = false;
  public search: string = '';
  public isRentals = false;
  public isWorkshop = true;
  public columns: any = [
  ];
  public totalRecords: number = 0;
  public page: number = 0;
  public limit: number = 15;
  public showExpired: boolean = false;
  public countryData: any = {};

  private modelChanged: Subject<string> = new Subject<string>();
  private subscription: Subscription;
  debounceTime = 250;

  constructor(
    private couponsService: CouponsService,
    private helpersService: HelpersService,
    private translate: TranslateService,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  inputChanged() {
    this.modelChanged.next('');
  }

  ngOnInit() {
    if (
      this.router.url.toLocaleLowerCase() ===
      '/store/rentals/coupons'
    ) {
      this.isRentals = true;
      this.isWorkshop = false;
    }

    this.setColumns();
    this.countryData = this.helpersService.getCountryData();
    this.subscription = this.modelChanged
      .pipe(debounceTime(this.debounceTime))
      .subscribe(() => {
        this.searchCoupons();
      });

    this.partner = this.helpersService.getPartnerData();
    console.log(this.partner);
    this.getCoupons();
  }

  setColumns(){
    if(this.isWorkshop){
      this.columns = [{
        header: this.translate.instant('general.headers.coupons.coupon_code'),
        field: 'couponCode',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.coupons.redeem_method'),
        field: 'redeemMethod',
        type: 'redeemMethod',
      },
      {
        header: this.translate.instant('general.headers.coupons.type'),
        field: 'type',
        type: 'type',
      },
      {
        header: this.translate.instant('general.headers.coupons.value'),
        field: '',
        type: 'value-type',
      },
      {
        header: this.translate.instant('general.headers.coupons.linked_to'),
        field: '',
        type: 'linked',
      },
      {
        header: this.translate.instant('general.headers.coupons.expiry_date'),
        field: 'expiryDate',
        type: 'date',
      },
      {
        header: this.translate.instant('general.headers.coupons.redemptions'),
        field: '',
        type: 'redemptions',
      }];
    }else if(this.isRentals){
      this.columns = [{
        header: this.translate.instant('general.headers.coupons.coupon_code'),
        field: 'couponCode',
        type: 'string',
      },
      {
        header: this.translate.instant('general.headers.coupons.type'),
        field: 'type',
        type: 'type',
      },
      {
        header: this.translate.instant('general.headers.coupons.value'),
        field: '',
        type: 'value-type',
      },
      {
        header: this.translate.instant('general.headers.coupons.expiry_date'),
        field: 'expiryDate',
        type: 'date',
      },
      {
        header: this.translate.instant('general.headers.coupons.redemptions'),
        field: '',
        type: 'redemptions',
      }];
    }
  }

  getCoupons() {
    if(this.isWorkshop){
    this.busy = true;
    this.couponsService
      .getCoupons(
        this.partner.ID,
        this.page,
        this.limit,
        this.showExpired,
        this.search,
      )
      .subscribe((coupons) => {
        this.totalRecords = coupons.totalRecords;
        this.page = coupons.page;
        this.limit = coupons.limit;

        this.coupons = coupons.coupons;
        this.coupons.forEach((coupon) => {
          var items = [];
          if (coupon.linkToServiceTypes)
            items.push(
              this.translate.instant(
                'general.headers.coupons.linked_to_service_types',
              ),
            );
          if (coupon.linkedToProductCategories)
            items.push(
              this.translate.instant(
                'general.headers.coupons.linked_to_product_categories',
              ),
            );
          if (coupon.linkedToUser)
            items.push(
              this.translate.instant('general.headers.coupons.linked_to_user'),
            );
          coupon.linkedItems = items.join(', ');
        });
        this.busy = false;
      });
    }else if(this.isRentals){
      this.busy = true;
      this.couponsService
        .getRentalCoupons(
          this.partner.ID,
          this.page,
          this.limit,
          this.showExpired,
          this.search,
        )
        .subscribe((coupons) => {
          this.totalRecords = coupons.totalRecords;
          this.page = coupons.page;
          this.limit = coupons.limit;
  
          this.coupons = coupons.coupons;
          this.coupons.forEach((coupon) => {
            var items = [];
            if (coupon.linkToServiceTypes)
              items.push(
                this.translate.instant(
                  'general.headers.coupons.linked_to_service_types',
                ),
              );
            if (coupon.linkedToProductCategories)
              items.push(
                this.translate.instant(
                  'general.headers.coupons.linked_to_product_categories',
                ),
              );
            if (coupon.linkedToUser)
              items.push(
                this.translate.instant('general.headers.coupons.linked_to_user'),
              );
            coupon.linkedItems = items.join(', ');
          });
          this.busy = false;
        });
    }
  }

  paginate(event) {
    this.page = event.page;
    this.limit = event.rows;
    this.getCoupons();
  }

  searchCoupons() {
    this.getCoupons();
  }

  addCoupon() {
    this.selectedCoupon = {
      expired: false,
      expiryDate: '',
      fixedValue: null,
      linkToServiceTypes: false,
      linkedToProductCategories: false,
      linkedToUser: false,
      linkedUsers: [],
      partnerID: this.partner.ID,
      percentValue: null,
      redeemMethod: 'ANY',
      type: this.isWorkshop ? 'FIXED_VALUE' : 'PERCENT',
      couponCode: '',
      numberRentalProductsToQualify: 0,
      minimumRentalSpendToQualify: 0,
      applyToRentalProducts: this.isRentals,
      applyToRentalAccessories: this.isRentals      
    };
    this.showCouponDetail = true;
  }

  editCoupon(coupon) {
    this.selectedCoupon = coupon;
    this.showCouponDetail = true;
  }

  closeCouponDetail() {
    this.showCouponDetail = false;
    this.getCoupons();
  }
}
